import { ReactElement } from 'react';
import { Topic } from './types';
import { Button, Badge, Dialog, DialogContent } from '@ff-it/ui';
import { useNavigationState } from './useNavigationState';
import { CommentStream } from './CommentSream';

export function CommentDialogToggle({
  topic,
  onTopicUpdate,
}: {
  topic: Topic;
  onTopicUpdate: (topic: Topic) => void;
}): ReactElement {
  const { isOpen, open, close, commentId } = useNavigationState(topic.object_key);
  return (
    <>
      <Badge count={topic.count} variant="secondary">
        <Button
          testId={`comments-${topic.object_key}`}
          size="xxs"
          variant={isOpen ? 'primary' : 'secondary'}
          icon="message"
          onClick={() => open()}
        />
      </Badge>
      <Dialog
        open={isOpen}
        onOpenChange={(isOpen) => {
          if (!isOpen) {
            close();
          }
        }}
      >
        <DialogContent testId="comment-stream" right overflow="hidden" p="0">
          <CommentStream topic={topic} onTopicUpdate={onTopicUpdate} commentId={commentId} />
        </DialogContent>
      </Dialog>
    </>
  );
}
